import { useAlert } from '../stores/alert';

const alertMixin = {
    methods: {
        $alert(options) {
            //TODO: Move the "validation" to the store (no standard way for this exists) OR just ignore OR leave it here
            let allowedOptions = ['type', 'title', 'text', 'confirmButton', 'confirmClass', 'cancelButton', 'cancelClass', 'timeout'];
            if (typeof options !== 'object') {
                throw "Parameters must be in format {'type': [string], 'title': [string], 'text': [string], 'confirmButton': [string], 'confirmClass': [string], 'cancelButton': [string], 'cancelClass': [string], 'timeout': [integer]}"
            }

            if (Object.keys(options).filter(x => !allowedOptions.includes(x)).length > 0) {
                throw "Invalid option";
            }

            const alertStore = useAlert();

            alertStore.show(options);

            return new Promise((resolve, reject) => {
                let unsubscribe = alertStore.$subscribe((mutation, state) => {
                    // Subscribe to alert closes, return "confirm" value (true/false) from store
                    if (mutation.type === "patch object" && mutation.payload.openDialog === false) {
                        resolve(state.confirm);
                        unsubscribe();
                    }
                });
            });
        }
    }
}

export default alertMixin;